import { Language } from '../Language/Language.types';

/**
 * Interface for AbsenceReasons with the name, countries that it is valid in
 * and boolean if a timeTracking should be created,
 * for an absence with this reason
 */
export interface AbsenceReason {
  id: string;
  createDate: Date;
  createdBy: string;
  lastUpdate: Date;
  updatedBy: string;
  name: string;
  translations: Map<Language, string>;
  validCompanies: string[];
  creatingTimeTracking: boolean;
  disabled: boolean;
  color: string;
  holidayReason: boolean;
  azkReduction: boolean;
}
/**
 * Helper method to generate an empty absenceReason
 * @param userId of the user that created the reason
 * @returns empty absenceReason
 */
export const generateEmptyAbsenceReason = (override?: Partial<AbsenceReason>): AbsenceReason => ({
  id: undefined!,
  createDate: new Date(),
  createdBy: undefined!,
  creatingTimeTracking: false,
  lastUpdate: new Date(),
  name: '',
  updatedBy: undefined!,
  validCompanies: [],
  translations: new Map<Language, string>(),
  disabled: false,
  color: 'red',
  holidayReason: false,
  azkReduction: false,
  ...override,
});
